import { DEFAULT_TARGET_MARGIN } from '../constants/survey-target-margin.constants';
import { Survey, SurveyMarginForm } from '../models';

export function surveyToMarginForm(survey: Survey): SurveyMarginForm {
  return {
    buyerCpi: survey.offerPrice ?? null,
    targetMargin: survey.marginOverride ?? DEFAULT_TARGET_MARGIN,
    userAcceptedMargin: !!survey.marginOverride,
  };
}
